import { Injectable } from '@angular/core';
import { GlobalDataBusService } from '../shared/global-data-bus.service';


@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  /**
     * Sets the loadingSub property value based on the following:
     * - If loading is true, add the provided url to the loadingMap with a true value, set loadingSub value to true
     * - If loading is false, remove the loadingMap entry and only when the map is empty will we set loadingSub to false
     * This pattern ensures if there are multiple requests awaiting completion, we don't set loading to false before
     * other requests have completed. At the moment, this function is only called from the @link{HttpRequestInterceptor}
     * @param loading {boolean}
     * @param url {string}
     */
  async setLoading(loading: boolean, url: string) {
    if (!url) {
      throw new Error('The request URL must be provided to the LoadingService.setLoading function');
    }
    if (loading === true) {
      GlobalDataBusService.loadingMap.set(url, loading);
      GlobalDataBusService.loadingSub.next(true);
    } else if (loading === false && GlobalDataBusService.loadingMap.has(url)) {
      GlobalDataBusService.loadingMap.delete(url);
    }
    if (GlobalDataBusService.loadingMap.size === 0) {
      GlobalDataBusService.loadingSub.next(false);
    }
  }
}
